import Stack from '@mui/material/Stack'
import Skeleton from '@mui/material/Skeleton'
import { StyledMatchCard } from './style'

const JobCardSkeleton: React.FC = () => {
  return (
    <StyledMatchCard>
      <Stack
        direction={{ xs: 'column', sm: 'row', md: 'column', lg: 'row' }}
        spacing={{ xs: 1, sm: 2.5, md: 1, lg: 2.5 }}
      >
        <Skeleton
          animation={false}
          variant="rounded"
          width={52}
          height={52}
          sx={{
            marginBottom: '3rem',
          }}
        />
        <Stack spacing={0.5} width={1}>
          <Skeleton
            variant="rectangular"
            width={'60%'}
            height={24}
            animation={false}
          />
          <Skeleton
            variant="rectangular"
            width={'80%'}
            height={24}
            animation={false}
          />
          <Stack direction={'row'} spacing={1} style={{ marginTop: 10 }}>
            <Skeleton
              variant="rounded"
              width={76}
              height={38}
              sx={{ borderRadius: '30px' }}
              animation={false}
            />
            <Skeleton
              variant="rounded"
              width={76}
              height={38}
              sx={{ borderRadius: '30px' }}
              animation={false}
            />
            <Skeleton
              variant="rounded"
              width={76}
              height={38}
              sx={{ borderRadius: '30px' }}
              animation={false}
            />
          </Stack>
        </Stack>
      </Stack>
    </StyledMatchCard>
  )
}

export default JobCardSkeleton
